module.exports = __webpack_public_path__ + "static/HyperparameterTuningCert-4b39595c350769b59d37ac95e25c1e74.jpg";